import { render, staticRenderFns } from "./VtTextarea.vue?vue&type=template&id=42c15772&scoped=true&"
import script from "./VtTextarea.vue?vue&type=script&lang=js&"
export * from "./VtTextarea.vue?vue&type=script&lang=js&"
import style0 from "./VtTextarea.vue?vue&type=style&index=0&id=42c15772&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42c15772",
  null
  
)

export default component.exports